import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import statsImg from "../assets/Col-1-993x1024.png";

const StatsSection = styled.section`
  padding: 8rem 5%;
  background-color: var(--background);
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 4rem;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
  }
`;

const Content = styled.div`
  max-width: 600px;

  h2 {
    color: var(--primary);
    font-size: clamp(2.5rem, 5vw, 4rem);
    margin-bottom: 1.5rem;
    line-height: 1.1;
  }

  p {
    color: var(--text-secondary);
    font-size: 1.25rem;
    margin-bottom: 4rem;
    line-height: 1.6;
  }
`;

const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
`;

const StatItem = styled.div`
  display: flex;
  flex-direction: column;
`;

const Number = styled.div`
  font-size: 5rem;
  font-weight: 800;
  color: var(--text-primary);
  line-height: 1;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: baseline;

  span {
    font-size: 2.5rem;
    margin-left: 0.25rem;
  }
`;

const Label = styled.div`
  font-size: 1.1rem;
  font-weight: 600;
  color: var(--text-primary);
`;

const ImageContainer = styled.div`
  img {
    width: 100%;
    border-radius: 1rem;
    object-fit: contain;
  }
`;

export const Stats: React.FC = () => {
  const { t } = useTranslation();
  return (
    <StatsSection>
      <Container>
        <Content>
          <h2>{t("stats.title")}</h2>
          <p>{t("stats.description")}</p>
          <StatsGrid>
            <StatItem>
              <Number>
                50<span>%</span>
              </Number>
              <Label>{t("stats.label1")}</Label>
            </StatItem>
            <StatItem>
              <Number>
                15-25<span>%</span>
              </Number>
              <Label>{t("stats.label2")}</Label>
            </StatItem>
          </StatsGrid>
        </Content>
        <ImageContainer>
          <img src={statsImg} alt={t("stats.alt_img")} />
        </ImageContainer>
      </Container>
    </StatsSection>
  );
};

